import { LoadingDots } from '@belong/ui';

// This is used to hard redirect to belong-next project.
export function PageRedirectToBelongNext() {
  window.location.replace(window.location.href);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingDots />
    </div>
  );
}
